import React from 'react'
import { utils } from 'alelo-logic'

import {
  Content,
  GroupItems,
  Item,
  ItemCell,
  ItemRow,
  ItemSpan,
  ItemSpanCenter,
  ItemStrong,
  ItemStrongGrey,
  Value,
  ValueBlue,
  ValueYellow
} from './styles'

import { benefits, parking, toll, veloeServices } from './data.json'

function renderHour(item, transacao) {
  return item.tipoTransacao === parking
    ? renderColor(item, transacao, `${transacao.horaEntrada || ''} / ${transacao.horaSaida || ''}`)
    : renderColor(item, transacao, transacao.hora || '')
}

function renderCategory(item, transacao) {
  if (item.tipoTransacao === toll) {
    if (transacao.categoria < 10)
      return renderColor(item, transacao, `${transacao.categoria || '-'}`)
    return renderColor(item, transacao, transacao.categoria)
  }
  if (item.tipoTransacao === parking)
    return renderColor(item, transacao, transacao.permanencia || '')
  return ''
}

function renderPlace(item, transacao) {
  if (item.tipoTransacao === veloeServices || item.tipoTransacao === benefits) {
    return <ItemStrongGrey>{renderColor(item, transacao, item.tipoTransacao)}</ItemStrongGrey>
  }
  return (
    <div>
      <ItemStrongGrey>{renderColor(item, transacao, transacao.estabelecimento)}</ItemStrongGrey>

      <ItemSpan>
        <span>{renderColor(item, transacao, transacao.endereco)}</span>
      </ItemSpan>
    </div>
  )
}

function renderValue(item, transacao) {
  if (item.tipoTransacao === benefits || !String(transacao.valor).includes('-'))
    return <ValueBlue>{utils.currencyParser(transacao.valor * -1)}</ValueBlue>
  return <Value>{utils.currencyParser(transacao.valor * -1)}</Value>
}

function renderColor(item, transacao, value) {
  if (item.tipoTransacao === benefits || !String(transacao.valor).includes('-'))
    return <ValueYellow>{value}</ValueYellow>
  return value
}

function renderItems(data) {
  return (
    data &&
    data.transacaoes &&
    data.transacaoes.map((transacao, i) => (
      <Item key={i}>
        <Content>
          <ItemRow align="center" justify="space-between">
            <ItemCell width={[1, 2 / 12]} />
            <ItemCell pl={[0, 20]} width={[1, 1 / 12]}>
              <ItemStrong>
                {renderColor(data, transacao, utils.ISODateFormat(transacao.data))}
              </ItemStrong>
            </ItemCell>
            <ItemCell pl={[0, 20]} width={[1, 2 / 12]}>
              <ItemSpanCenter>{renderHour(data, transacao)}</ItemSpanCenter>
            </ItemCell>
            <ItemCell pl={[0, 20]} width={[1, 1 / 12]}>
              <ItemSpanCenter>{renderCategory(data, transacao)}</ItemSpanCenter>
            </ItemCell>
            <ItemCell pl={[0, 20]} width={[1, 5 / 12]}>
              {renderPlace(data, transacao)}
            </ItemCell>
            <ItemCell pl={[0, 20]} width={[1, 1 / 12]}>
              {renderValue(data, transacao)}
            </ItemCell>
          </ItemRow>
        </Content>
      </Item>
    ))
  )
}

const InvoiceDetailsListItems = ({ data }) => data && <GroupItems>{renderItems(data)}</GroupItems>

export default InvoiceDetailsListItems



// WEBPACK FOOTER //
// ./src/app/elements/InvoiceDetailsListItems/index.js